export const PersonalInformationPath = '/settings/personal-information';
export const SecurityPath = '/settings/security';
export const SubscriptionPath = '/settings/subscription';
export const BillingPath = '/settings/billing';
